module.exports = "https://web-assets.ifttt.com/packs/media/products/device-watchos-7e0ec9eb.png";